import { render } from "./auth-layout.vue?vue&type=template&id=406b5d5f"
import script from "./auth-layout.vue?vue&type=script&lang=js"
export * from "./auth-layout.vue?vue&type=script&lang=js"

import "./auth-layout.vue?vue&type=style&index=0&id=406b5d5f&lang=scss"

import exportComponent from "/home/admin/dimensional-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__